
<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>

    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'1-1'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>
            시스템 관리 - 메뉴권한 {{ $route.query.menu_permission_ID === undefined ? '등록' : '수정' }}
          </p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn01" v-on:click="check_form">
              {{ $route.query.menu_permission_ID === undefined ? '등록' : '수정' }}
            </button>
          </div>
        </div>

        <div class="Admin_PageDetail">
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='menu_permission_name'>메뉴 권한명<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'menu_permission_name'
                maxLength="50"
                placeholder = "메뉴 권한명을 입력해 주세요."
                v-model="formData.menuPermissionName"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.menuPermissionNameError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='menu_permission_status'>사용 여부<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="menu_permission_status"
                v-model="formData.menuPermissionStatus"
              >
                <option value='1'>사용</option>
                <option value='2'>미사용</option>
              </select>
            </div>
          </div>

          <div class="Admin_PermissionBox">
            <div class="Admin_Permission_MainDiv">
              <label for='checkbox_menu_1' class="Admin_labelCheck Admin_labelCheck_First">
                시스템 관리
                <input
                type='checkbox'
                id = 'checkbox_menu_1'
                v-on:click="insert_menu_permission_check_box_all($event, ['1', '1-1', '1-2', '1-3', '1-4', '1-5', '1-6', '1-7', '1-8', '1-9', '1-10'])"
                :checked="check_box_bool_judgement('1')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>

            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_1_1' class="Admin_labelCheck">
                메뉴권한 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_1_1'
                  v-on:click="insert_menu_permission_check_box($event, '1', '1-1')"
                  :checked="check_box_bool_judgement('1-1')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>

            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_1_2' class="Admin_labelCheck">
                사용자 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_1_2'
                  v-on:click="insert_menu_permission_check_box($event, '1', '1-2')"
                  :checked="check_box_bool_judgement('1-2')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>

            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_1_3' class="Admin_labelCheck">
                HOT 키워드 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_1_3'
                  v-on:click="insert_menu_permission_check_box($event, '1', '1-3')"
                  :checked="check_box_bool_judgement('1-3')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>

            <!-- <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_1_4' class="Admin_labelCheck">
                이용안내 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_1_4'
                  v-on:click="insert_menu_permission_check_box($event, '1', '1-4')"
                  :checked="check_box_bool_judgement('1-4')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>

            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_1_5' class="Admin_labelCheck">
                취소/환불 규정 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_1_5'
                  v-on:click="insert_menu_permission_check_box($event, '1', '1-5')"
                  :checked="check_box_bool_judgement('1-5')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div> -->

            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_1_6' class="Admin_labelCheck">
                메세지 로그
                <input
                  type='checkbox'
                  id = 'checkbox_menu_1_6'
                  v-on:click="insert_menu_permission_check_box($event, '1', '1-6')"
                  :checked="check_box_bool_judgement('1-6')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>

            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_1_7' class="Admin_labelCheck">
                포인트 로그
                <input
                  type='checkbox'
                  id = 'checkbox_menu_1_7'
                  v-on:click="insert_menu_permission_check_box($event, '1', '1-7')"
                  :checked="check_box_bool_judgement('1-7')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>
            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_1_8' class="Admin_labelCheck">
                팝업 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_1_8'
                  v-on:click="insert_menu_permission_check_box($event, '1', '1-8')"
                  :checked="check_box_bool_judgement('1-8')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>
            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_1_9' class="Admin_labelCheck">
                문자 발송
                <input
                  type='checkbox'
                  id = 'checkbox_menu_1_9'
                  v-on:click="insert_menu_permission_check_box($event, '1', '1-9')"
                  :checked="check_box_bool_judgement('1-9')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>
            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_1_10' class="Admin_labelCheck">
                혜택 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_1_10'
                  v-on:click="insert_menu_permission_check_box($event, '1', '1-10')"
                  :checked="check_box_bool_judgement('1-10')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>
          </div>

          <div class="Admin_PermissionBox">
            <div class="Admin_Permission_MainDiv">
              <label for='checkbox_menu_2' class="Admin_labelCheck Admin_labelCheck_First">
                회원 관리
                <input
                type='checkbox'
                id = 'checkbox_menu_2'
                v-on:click="insert_menu_permission_check_box_all($event, ['2', '2-1'])"
                :checked="check_box_bool_judgement('2')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>

            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_2_1' class="Admin_labelCheck">
                회원 현황
                <input
                  type='checkbox'
                  id = 'checkbox_menu_2_1'
                  v-on:click="insert_menu_permission_check_box($event, '2', '2-1')"
                  :checked="check_box_bool_judgement('2-1')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>
          </div>

          <div class="Admin_PermissionBox">
            <div class="Admin_Permission_MainDiv">
              <label for='checkbox_menu_5' class="Admin_labelCheck Admin_labelCheck_First">
               메뉴 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_5'
                  v-on:click="insert_menu_permission_check_box_all($event, ['5', '5-1'])"
                  :checked="check_box_bool_judgement('5')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>

            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_5_1' class="Admin_labelCheck">
                공연 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_5_1'
                  v-on:click="insert_menu_permission_check_box($event, '5', '5-1')"
                  :checked="check_box_bool_judgement('5')"
                />
                 <span class="Admin_checkOn"></span>
              </label>
            </div>
          </div>

          <div class="Admin_PermissionBox">
            <div class="Admin_Permission_MainDiv">
              <label for='checkbox_menu_7' class="Admin_labelCheck Admin_labelCheck_First">
               푸터 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_7'
                  v-on:click="insert_menu_permission_check_box_all($event, ['7', '7-1'])"
                  :checked="check_box_bool_judgement('7')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>

            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_7_1' class="Admin_labelCheck">
                협력업체 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_7_1'
                  v-on:click="insert_menu_permission_check_box($event, '7', '7-1')"
                  :checked="check_box_bool_judgement('7')"
                />
                 <span class="Admin_checkOn"></span>
              </label>
            </div>
          </div>

          <div class="Admin_PermissionBox">
            <div class="Admin_Permission_MainDiv">
              <label for='checkbox_menu_3' class="Admin_labelCheck Admin_labelCheck_First">
               메인화면 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_3'
                  v-on:click="insert_menu_permission_check_box_all($event, ['3', '3-1', '3-2', '3-3', '3-4'])"
                  :checked="check_box_bool_judgement('3')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>

            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_3_1' class="Admin_labelCheck">
                롤링 배너 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_3_1'
                  v-on:click="insert_menu_permission_check_box($event, '3', '3-1')"
                  :checked="check_box_bool_judgement('3')"
                />
                 <span class="Admin_checkOn"></span>
              </label>
            </div>
            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_3_2' class="Admin_labelCheck">
                추천여행 배너 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_3_2'
                  v-on:click="insert_menu_permission_check_box($event, '3', '3-2')"
                  :checked="check_box_bool_judgement('3')"
                />
                 <span class="Admin_checkOn"></span>
              </label>
            </div>
            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_3_3' class="Admin_labelCheck">
                이달의 추천여행 배너 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_3_3'
                  v-on:click="insert_menu_permission_check_box($event, '3', '3-3')"
                  :checked="check_box_bool_judgement('3')"
                />
                 <span class="Admin_checkOn"></span>
              </label>
            </div>
            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_3_4' class="Admin_labelCheck">
                고정 배너 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_3_4'
                  v-on:click="insert_menu_permission_check_box($event, '3', '3-4')"
                  :checked="check_box_bool_judgement('3')"
                />
                 <span class="Admin_checkOn"></span>
              </label>
            </div>
          </div>

          <div class="Admin_PermissionBox">
            <div class="Admin_Permission_MainDiv">
              <label for='checkbox_menu_8' class="Admin_labelCheck Admin_labelCheck_First">
                커뮤니티 관리
                <input
                type='checkbox'
                id = 'checkbox_menu_8'
                v-on:click="insert_menu_permission_check_box_all($event, ['8', '8-1', '8-2', '8-3', '8-4', '8-5'])"
                :checked="check_box_bool_judgement('8')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>

            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_8_1' class="Admin_labelCheck">
                공지사항 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_8_1'
                  v-on:click="insert_menu_permission_check_box($event, '8', '8-1')"
                  :checked="check_box_bool_judgement('8-1')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>

            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_8_2' class="Admin_labelCheck">
                여행후기 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_8_2'
                  v-on:click="insert_menu_permission_check_box($event, '8', '8-2')"
                  :checked="check_box_bool_judgement('8-2')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>

            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_8_3' class="Admin_labelCheck">
                온라인문의 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_8_3'
                  v-on:click="insert_menu_permission_check_box($event, '8', '8-3')"
                  :checked="check_box_bool_judgement('8-3')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>

            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_8_4' class="Admin_labelCheck">
                자주 묻는 질문 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_8_4'
                  v-on:click="insert_menu_permission_check_box($event, '8', '8-4')"
                  :checked="check_box_bool_judgement('8-4')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>
            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_8_5' class="Admin_labelCheck">
                단체여행 문의 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_8_5'
                  v-on:click="insert_menu_permission_check_box($event, '8', '8-5')"
                  :checked="check_box_bool_judgement('8-5')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>
          </div>

          <div class="Admin_PermissionBox">
            <div class="Admin_Permission_MainDiv">
              <label for='checkbox_menu_4' class="Admin_labelCheck Admin_labelCheck_First">
                여행 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_4'
                  v-on:click="insert_menu_permission_check_box_all($event, ['4', '4-1', '4-2', '4-3', '4-4'])"
                  :checked="check_box_bool_judgement('4')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>

            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_4_1' class="Admin_labelCheck">
                여행타입 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_4_1'
                  v-on:click="insert_menu_permission_check_box($event, '4', '4-1')"
                  :checked="check_box_bool_judgement('4-1')"
                />
                 <span class="Admin_checkOn"></span>
              </label>
            </div>
            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_4_2' class="Admin_labelCheck">
                여행상품 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_4_2'
                  v-on:click="insert_menu_permission_check_box($event, '4', '4-2')"
                  :checked="check_box_bool_judgement('4-2')"
                />
                 <span class="Admin_checkOn"></span>
              </label>
            </div>
            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_4_3' class="Admin_labelCheck">
                여행일정 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_4_3'
                  v-on:click="insert_menu_permission_check_box($event, '4', '4-3')"
                  :checked="check_box_bool_judgement('4-3')"
                />
                 <span class="Admin_checkOn"></span>
              </label>
            </div>
            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_4_4' class="Admin_labelCheck">
                여행관리 시스템(TMS)
                <input
                  type='checkbox'
                  id = 'checkbox_menu_4_4'
                  v-on:click="insert_menu_permission_check_box($event, '4', '4-4')"
                  :checked="check_box_bool_judgement('4-4')"
                />
                 <span class="Admin_checkOn"></span>
              </label>
            </div>
          </div>

          <div class="Admin_PermissionBox">
            <div class="Admin_Permission_MainDiv">
              <label for='checkbox_menu_6' class="Admin_labelCheck Admin_labelCheck_First">
               결제 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_6'
                  v-on:click="insert_menu_permission_check_box_all($event, ['6', '6-1', '6-2'])"
                  :checked="check_box_bool_judgement('6')"
                />
                <span class="Admin_checkOn"></span>
              </label>
            </div>

            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_6_1' class="Admin_labelCheck">
                결제 현황
                <input
                  type='checkbox'
                  id = 'checkbox_menu_6_1'
                  v-on:click="insert_menu_permission_check_box($event, '6', '6-1')"
                  :checked="check_box_bool_judgement('6')"
                />
                 <span class="Admin_checkOn"></span>
              </label>
            </div>
            <div class="Admin_Permission_MainDiv Admin_Permission_SubDiv">
              <label for='checkbox_menu_6_2' class="Admin_labelCheck">
                바로결제 관리
                <input
                  type='checkbox'
                  id = 'checkbox_menu_6_2'
                  v-on:click="insert_menu_permission_check_box($event, '6', '6-2')"
                  :checked="check_box_bool_judgement('6')"
                />
                 <span class="Admin_checkOn"></span>
              </label>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import Spiner from '../../Homepage/Section/Spiner.vue'
import {
  get_menu_permission_one,
  insert_menu_permission,
  update_menu_permission
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminMenuPermissionManagementAdd',
  components: {
    AdminHeader,
    AdminFooter,
    Spiner

  },
  setup () {
    return {
      formData: ref({
        menuPermissionName: '',
        menuPermissionStatus: 1,
        menuPermissionArray: []
      }),
      errorData: ref({
        menuPermissionNameError: ''
      }),
      statusData: ref({
        spinnerStatus: false
      })
    }
  },
  methods: {
    check_box_bool_judgement: function (menu_ID) {
      let bool = false
      for (let i = 0; i < this.formData.menuPermissionArray.length; i++) {
        if (this.formData.menuPermissionArray[i] === menu_ID) {
          bool = true
        }
      }
      return bool
    },
    insert_menu_permission_check_box: function (event, big_menu_ID, menu_ID) {
      if (event.target.checked === true) {
        if (!this.check_box_bool_judgement(big_menu_ID)) {
          this.formData.menuPermissionArray.push(big_menu_ID)
        }
        this.formData.menuPermissionArray.push(menu_ID)
      } else {
        for (let i = 0; i < this.formData.menuPermissionArray.length; i++) {
          if (this.formData.menuPermissionArray[i] === menu_ID) {
            this.formData.menuPermissionArray.splice(i, 1)
            i--
          }
        }
      }
    },
    insert_menu_permission_check_box_all: function (event, menu_ID) {
      menu_ID.forEach(element => {
        if (event.target.checked === true) {
          if (!this.check_box_bool_judgement(element)) {
            this.formData.menuPermissionArray.push(element)
          }
        } else {
          for (let i = 0; i < this.formData.menuPermissionArray.length; i++) {
            if (this.formData.menuPermissionArray[i] === element) {
              this.formData.menuPermissionArray.splice(i, 1)
              i--
            }
          }
        }
      })
    },
    check_form: function () {
      let continue_add = true
      if (this.formData.menuPermissionName === '') {
        this.errorData.menuPermissionNameError = '메뉴 권한명을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.menuPermissionNameError = ''
      }
      if (continue_add) {
        this.statusData.spinnerStatus = true
        if (this.$route.query.menu_permission_ID === undefined) {
          insert_menu_permission(
            this.formData.menuPermissionName,
            this.formData.menuPermissionStatus,
            JSON.stringify(this.formData.menuPermissionArray)
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('등록이 완료되었습니다.')
            window.location.href = '/AdminMenuPermissionManagement'
          })
        } else {
          update_menu_permission(
            this.$route.query.menu_permission_ID,
            this.formData.menuPermissionName,
            this.formData.menuPermissionStatus,
            JSON.stringify(this.formData.menuPermissionArray)
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('수정이 완료되었습니다.')
            window.location.href = '/AdminMenuPermissionManagement'
          })
        }
      } else {
        alert('필수 입력값을 확인해주세요.')
      }
    }
  },
  mounted () {
    if (this.$route.query.menu_permission_ID !== undefined) {
      get_menu_permission_one(this.$route.query.menu_permission_ID).then((result) => {
        this.formData.menuPermissionArray = JSON.parse(result[0].menu_permission_array)
        this.formData.menuPermissionName = result[0].menu_permission_name
        this.formData.menuPermissionStatus = result[0].menu_permission_status
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/SystemManagement/AdminMenuPermissionManagementAdd.vue